// Copyright (c) 2016 Deere & Company

import Countries, {getDefaultState} from '../state/countries';
import actions from '../../actions-list';

const updateCountries = (state, action) =>
    Countries.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_STATUS_CHANGE_COUNTRIES_SUCCESS]: updateCountries
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/status-change-request/reducers/countries.js